<div class="yard-simulator">
  <sc-master-detail [selection]="[selectedMenuEntry]" [data]="menuEntries" [showDelete]="false" [readOnly]="true" [newStyle]="true"
    (selectionChanged)="onSimulatorMenuEntryChanged($event)">
    <div class="component" [ngSwitch]="selectedMenuEntry.identifier">
      <app-number-plate-scan *ngSwitchCase="'number-plate-scan'"></app-number-plate-scan>
      <app-rfid-reader *ngSwitchCase="'rfid-reader'"></app-rfid-reader>
      <app-barcode-reader *ngSwitchCase="'barcode-reader'"></app-barcode-reader>
    </div>
  </sc-master-detail>
</div>
